// Environment Configuration
const environment = {
  development: {
    API_URL: 'http://localhost:3001',
    NODE_ENV: 'development'
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL || 'https://your-railway-backend.up.railway.app',
    NODE_ENV: 'production'
  }
};

// Get current environment
const currentEnv = process.env.NODE_ENV || 'development';

// Export current environment configuration
export const config = environment[currentEnv];

// Export API URL for backward compatibility
export const API_BASE_URL = config.API_URL;

export default config; 